import { z } from "zod";
export const AI_ALLOWANCE_REACHED = "ai_allowance_reached";
export const AI_ALLOWANCE_CHECK_INTERVAL_MS = 30_000;
export const AI_ALLOWANCE_STOP_SUMMARY = "This run was stopped because its AI budget was reached. Your saved work is preserved. The app's AI page shows what's left and when it resets.";
/** Stored on runs stopped before the AI page replaced Agent capacity settings. */
export const AI_ALLOWANCE_STOP_SUMMARY_LEGACY = "This run was stopped because its shared AI allowance was reached. Your saved work is preserved. Check AI capacity in Agent settings for usage and reset times.";
export function isAiAllowanceStopSummary(value) {
    return value === AI_ALLOWANCE_STOP_SUMMARY || value === AI_ALLOWANCE_STOP_SUMMARY_LEGACY;
}
const amount = z.string().regex(/^(0|[1-9][0-9]*)$/);
const allowance = z.object({
    limit: amount.nullable(), available: amount.nullable(),
    used: amount,
});
/** The installation's AI: a small trial, plus promotional credit that outlives it. */
export const includedAiStateSchema = z.object({
    offered: z.boolean(),
    trial: z.object({
        state: z.enum(["active", "ended", "none"]),
        totalNanodollars: amount.nullable(),
        remainingNanodollars: amount.nullable(),
        endedAt: z.iso.datetime({ offset: true }).nullable(),
        endReason: z.enum(["organisation_account", "member_account", "personal_account", "administrator"]).nullable(),
    }),
    credit: z.object({
        remainingNanodollars: amount,
        nextExpiresAt: z.iso.datetime({ offset: true }).nullable(),
    }).nullable(),
});
export const capacityBudgetSummarySchema = z.object({
    organisationId: z.uuid(), organisationName: z.string().nullable(),
    period: z.object({ endsAt: z.iso.datetime(), timeZone: z.string() }),
    /** The viewer's weekly limit on the organisation's own accounts. */
    organisation: allowance.nullable(),
    /** Legacy weekly OpenCloud pool; now the remaining trial and credit. */
    opencloud: allowance,
    /** Optional weekly budget across all of the organisation's own accounts. */
    organisationBudget: allowance.nullable().optional(),
    /** The viewer's own budget across their own accounts (UTC weeks). */
    personalBudget: allowance.nullable().optional(),
    included: includedAiStateSchema.optional(),
});
const account = z.object({
    id: z.uuid(), label: z.string(), provider: z.string(), status: z.string(), isDefault: z.boolean(),
});
export const agentCapacitySummarySchema = capacityBudgetSummarySchema.extend({
    personalAccounts: z.array(account), appAccounts: z.array(account), organisationAccounts: z.array(account),
});
//# sourceMappingURL=capacity-summary.js.map